import React, { useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Tag from './Tag';
import { useChildrenFolding } from '../utils/hooks/useChildrenFolding';
import s from './Tags.scss';
var MAX_LINES = 2;
var TAG_SPACING = parseInt(s['tag-spacing'], 10);
var TOGGLE_BUTTON_WIDTH = parseInt(s['more-button-width'], 10);
var MAX_TAG_WIDTH = parseInt(s['max-tag-width'], 10);
// Component Index: C41
export var Tags = function (_a) {
    var tags = _a.tags, className = _a.className, _b = _a.isFoldable, isFoldable = _b === void 0 ? true : _b;
    var t = useTranslation().t;
    var _c = useState(!isFoldable), showAll = _c[0], setShowAll = _c[1];
    var _d = useChildrenFolding(tags, {
        maxLines: MAX_LINES,
        itemSpacing: TAG_SPACING,
        endPadding: TOGGLE_BUTTON_WIDTH,
        maxItemWidth: MAX_TAG_WIDTH,
        getItemKey: function (tag) { return tag.name; },
        excludeChild: function (element) { return element.classList.contains(s['show-all']); },
    }), sizedItems = _d.sizedItems, hasHidden = _d.hasHidden, containerRef = _d.containerRef;
    return (React.createElement("div", { className: classnames(s['tags-wrap'], showAll && s['all'], className), ref: containerRef },
        sizedItems.map(function (_a) {
            var item = _a.item, isOverflow = _a.isOverflow, isOversized = _a.isOversized;
            return (React.createElement(Tag, { key: item.name, tag: item, isOverflow: isOverflow, isOversized: isOversized }));
        }),
        isFoldable && hasHidden && (React.createElement("a", { onClick: function () { return setShowAll(!showAll); }, className: classnames(s['tag'], s['show-all']) }, t(showAll ? 'common.less' : 'common.more')))));
};
Tags.displayName = 'Tags';
export default Tags;
//# sourceMappingURL=Tags.js.map